// web-screen-budget הכרעה 7: מקום הגלילה והטיוטה לכל שיחה — "פתח" ליצירה ו"חזור" מחזירים לאותו תור עם מה שהוקלד.
// sessionStorage (לשונית אחת, נמחק בסגירה) — נוחות בלבד: אחסון חסום/מלא = כאילו אין ערך, בלי שגיאה.
// web-session-across-windows: הכניסה עברה ל-localStorage (כל הלשוניות), אבל זה נשאר פר-לשונית בכוונה — שתי לשוניות על אותה שיחה
// לא דורסות זו לזו טיוטה וגלילה.
const scrollKey = (id: string) => `ab.scroll.${id}`;
const draftKey = (id: string) => `ab.draft.${id}`;

function get(k: string): string | null {
  try {
    return sessionStorage.getItem(k);
  } catch {
    return null;
  }
}
function set(k: string, v: string | null) {
  try {
    if (v === null) sessionStorage.removeItem(k);
    else sessionStorage.setItem(k, v);
  } catch {
    /* חסום — בלי שחזור */
  }
}

export const convMemory = {
  readScroll(id: string): number | null {
    const v = get(scrollKey(id));
    const n = v === null ? NaN : Number(v);
    return Number.isFinite(n) && n >= 0 ? n : null;
  },
  saveScroll: (id: string, top: number) => set(scrollKey(id), String(Math.round(top))),
  readDraft: (id: string) => get(draftKey(id)),
  saveDraft: (id: string, text: string) => set(draftKey(id), text ? text : null),
};
